import { render, staticRenderFns } from "./DetailCreditsByCar.vue?vue&type=template&id=59a8c669&scoped=true&"
import script from "./DetailCreditsByCar.vue?vue&type=script&lang=ts&"
export * from "./DetailCreditsByCar.vue?vue&type=script&lang=ts&"
import style0 from "./DetailCreditsByCar.vue?vue&type=style&index=0&id=59a8c669&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a8c669",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VContainer,VProgressLinear})
